import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId } from '../common';
import { ClientId } from './ClientId';

export interface ClientBrandColour extends HasId, FullAuditable {
    clientId: ClientId;
    name: string;
    colour: string;
    order: number;
}

export interface CreateClientBrandColour {
    name: string;
    colour: string;
}

export interface UpdateClientBrandColour {
    colour: string;
}

export type ClientBrandColourId = TypeBrand<number, 'ClientBrandColourId'>;
export const ClientBrandColourId = createBranded<ClientBrandColourId>();
